<template>
    <SlideIntroLayout class="override" :videoUrl="require('@/assets/vids/intro-1.mp4')" :slideIndex="0" :durationMs="9000" nextPageId="AlphaGoat01S2">
        <template #description>
            Alpha G.O.A.T: A 10,000-Piece Digital Legacy
        </template>
    </SlideIntroLayout>
</template>